import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M19 13.01H21V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H10.99V5H5V19H19.01V13.01H19ZM11.71 13.74L18.98 6.44V9.98H20.99V3H13.97V5.01H17.56L10.29 12.31L11.71 13.74Z" fill={ fill || 'currentColor' } />
        </svg>
);
